import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Wheat, Factory, Cpu, Shirt, Boxes } from "lucide-react";
import { Card3D } from "@/components/3d/Card3D";

const industries = [
  {
    icon: Wheat,
    title: "Agriculture & Food",
    description: "Premium spices, grains, organic produce, and processed food products for global markets.",
  },
  {
    icon: Factory,
    title: "Industrial Machinery",
    description: "Heavy equipment, manufacturing tools, and industrial components from trusted producers.",
  },
  {
    icon: Cpu,
    title: "Electronics",
    description: "Consumer electronics, components, and tech accessories meeting international standards.",
  },
  {
    icon: Shirt,
    title: "Textiles & FMCG",
    description: "Apparel, fabrics, home textiles, and fast-moving consumer goods at competitive prices.",
  },
  {
    icon: Boxes,
    title: "Raw Materials",
    description: "Minerals, chemicals, metals, and other essential raw materials for manufacturing.",
  },
];

export function IndustriesSection() {
  return (
    <section className="py-24 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-1/2 left-0 w-72 h-72 bg-primary/5 rounded-full blur-3xl -translate-x-1/2" />
      <div className="absolute top-1/4 right-0 w-72 h-72 bg-primary/5 rounded-full blur-3xl translate-x-1/2" />

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-4">
            Diverse Sector <span className="text-gradient-gold">Expertise</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Serving multiple industries with specialized knowledge and established supplier networks.
          </p>
        </div>

        {/* Industries Grid with 3D Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {industries.map((industry, index) => (
            <Card3D
              key={industry.title}
              className={index === 4 ? "lg:col-start-2" : ""}
            >
              <div className="group h-full p-8 rounded-2xl bg-gradient-card border border-border hover:border-primary/50 transition-all duration-300">
                <div className="w-14 h-14 rounded-xl bg-secondary flex items-center justify-center mb-6 group-hover:bg-primary/10 transition-colors group-hover:shadow-[0_0_25px_hsl(43_70%_47%/0.25)]">
                  <industry.icon className="w-7 h-7 text-primary" />
                </div>
                <h3 className="text-xl font-serif font-semibold text-foreground mb-3">
                  {industry.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {industry.description}
                </p>
              </div>
            </Card3D>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Link to="/industries">
            <Button variant="goldOutline" size="lg" className="backdrop-blur-sm">
              Explore All Industries
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
